module.exports = __webpack_public_path__ + "img/dir_win_list.637cccac.png";